import React from "react";
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Figure from 'react-bootstrap/Figure';
import Carousel from 'react-bootstrap/Carousel';
import withContext from "../../withContext"; 
import Button from 'react-bootstrap/Button';
import outofstock from './sold_out.png';
import cross from './close.png';
import maestro from './payLogos/maestro.png';
import mastercard from './payLogos/mastercard.png';
import visa from './payLogos/visa_electron.png';
import ideal from './payLogos/ideal-logo-1024.png';
import stripe from './payLogos/stripe.png';
import { trackViewItem, trackAddToCart } from '../../firebase';





class Item extends React.Component {
  state = {
    expanded: false,
    activeIndex: 0
  };
  _viewTracked = false;

  addToCart = this.props.context.addToCart;
  refresh = this.props.context.refresh();

  componentDidMount() {
    document.body.style.paddingTop = "6em";
    this.props.context.refresh();
    // Ensure the item page opens at the top rather than scrolled down
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    document.body.style.paddingTop = "0";
  }

  handleExpand = (idx = 0) => {
    this.setState({ expanded: true, activeIndex: idx });
  };

  handleCollapse = (e) => {
    e.stopPropagation();
    this.setState({ expanded: false });
  };

  handlePrev = () => {
    const { activeIndex } = this.state;
    const images = this.currentImages || [];
    const count = images.length;
    this.setState({ activeIndex: (activeIndex - 1 + count) % count });
  };

  handleNext = () => {
    const { activeIndex } = this.state;
    const images = this.currentImages || [];
    const count = images.length;
    this.setState({ activeIndex: (activeIndex + 1) % count });
  };

  handleKeyDown = (e) => {
    if (!this.state.expanded) return;
    if (e.key === 'Escape') {
      this.setState({ expanded: false });
    } else if (e.key === 'ArrowLeft') {
      this.handlePrev();
    } else if (e.key === 'ArrowRight') {
      this.handleNext();
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.expanded !== this.state.expanded) {
      if (this.state.expanded) {
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', this.handleKeyDown);
      } else {
        document.body.style.overflow = '';
        window.removeEventListener('keydown', this.handleKeyDown);
      }
    }
  }

  render (){
    const { expanded } = this.state;

    const { products, cart } = this.props.context;
    let currentprops = this.props.location.aboutProps;

    if (currentprops !== undefined){
      // console.log(`currentprops is defined, proceed...; ${JSON.stringify(currentprops)}`);
      // localStorage.setItem("lastusedprops", JSON.stringify(currentprops));

    } else {
      // console.log(`currentprops is undefined, proceed...`);
      products.forEach(product => {
        let web = window.location.href;
        let index = web.indexOf(product.id);

        if (index !== -1){
          // console.log('index!==-1?')
          currentprops = ({"product": product });
          // console.log(`im assigning currentprops after retrieve data from URL, currentprops is ${JSON.stringify(currentprops)}`);
        }
      })

       // currentprops = JSON.parse(localStorage.getItem("lastusedprops"));
      // console.log(`im calling currentprops after retrieve data from localstorage, currentprops is ${currentprops}`);
        
      if (typeof currentprops === undefined){
          return (
            <div className="column">
            <span className="title has-text-grey-light">
                No products found :( Wait for a bit please
            </span>
            </div>
          )
      }
    }
    // console.log(currentprops.product.id)
    if (!this._viewTracked && currentprops && currentprops.product) {
      this._viewTracked = true;
      trackViewItem(currentprops.product);
    }
    function ousidecart(){
      if (cart){
        var values = [];
        Object.values(cart).forEach(value => values.push(value.product.id))
        if (values.includes(currentprops.product.id)){
          return true
        }
      }
    };
    ;
  

    // Build image list and keep a ref for handlers
    const images = [
      currentprops?.product?.URLp,
      currentprops?.product?.URLp2,
      currentprops?.product?.URLp3,
      currentprops?.product?.URLp4,
      currentprops?.product?.URLp5
    ].filter(u => u && u.length > 5);
    this.currentImages = images;

    return (
      <>
      {products&&products.length>1 ? (
      <Container>
        <Row className="ItemMainContainer mt-5">
          <Col xs className="MainShopItemCarouselContainer">
            
            <Carousel
              controls={true}
              indicators={true}
              interval={null}
              className={"ShopItemCarousel" + (expanded ? " GalleryBackground" : "")}
              id="CarouselToAppend"
              activeIndex={this.state.activeIndex}
              onSelect={(selectedIndex) => this.setState({ activeIndex: selectedIndex })}
              style={expanded ? { width:'100vw', height:'100vh'} : { width: (window.screen.width >= 769 ? '560px' : 'min(360px, calc(100vw - 40px))'), height:(window.screen.width >= 769 ? '560px' : 'min(360px, calc(100vw - 40px))') }}
            >
              {images.map((url, idx) => (
                  <Carousel.Item
                    className="ShopItem"
                    key={idx}
                    style={expanded ? { width:'100%', height:'100%'} : { width: (window.screen.width >= 769 ? '560px' : 'min(360px, calc(100vw - 40px))'), height:(window.screen.width >= 769 ? '560px' : 'min(360px, calc(100vw - 40px))') }}
                  >
                    <div
                      id="CarouselItemToAppend"
                      className="glry"
                      style={expanded ? { width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center'} : {}}
                    >
                      <Figure.Image
                        className={"ShopItemCarouselToAppend " + (expanded ? 'glryimg' : 'img-fluid')}
                        onClick={!expanded ? () => this.handleExpand(idx) : undefined}
                        src={url}
                        alt="something goes wrong :("
                        style={expanded ? { maxWidth:'90vw', maxHeight:'85vh', objectFit:'contain'} : { width: (window.screen.width >= 769 ? '560px' : 'min(360px, calc(100vw - 40px))'), height:(window.screen.width >= 769 ? '560px' : 'min(360px, calc(100vw - 40px))'), objectFit: 'cover' }}
                      />
                    </div>
                  </Carousel.Item>
                ))}
            </Carousel>

            {expanded && (
              <>
                <div className="LightboxNav left" onClick={this.handlePrev} aria-label="Previous image" />
                <div className="LightboxNav right" onClick={this.handleNext} aria-label="Next image" />
              <button
                type="button"
                className="LightboxClose"
                aria-label="Close gallery view"
                onClick={this.handleCollapse}
              >
                <img src={cross} alt="Close" />
              </button>
              </>
            )}

          </Col>
      
          <Col xs className="MainItemDescriptionContainer item-info-entry" style={{ marginTop: '-0.5rem', paddingTop: 0 }}>
            <Row style={{ marginTop: 0 }}>
              <h1 className="item-title" style={{ fontWeight: 400, fontSize: '2.5em', marginBottom: '0.5rem', marginTop: '0' }}>{currentprops.product.name}</h1>
            </Row>
            <Row>
              <p className="item-short-desc" style={{ fontSize: '1.2em', lineHeight: '1.5', fontWeight: 400, marginBottom: '1rem' }}>{currentprops.product.shortDesc}</p>          
            </Row>
            <Row>
              <p className="item-desc" style={{ fontSize: '1.1em', lineHeight: '1.5', fontWeight: 400, marginBottom: '1.5rem' }}>{currentprops.product.description}</p>          
            </Row>
            <Row>
              <h3 className="item-price" style={{ fontWeight: 600, fontSize: '2em', marginBottom: '1.5rem' }}>{currentprops.product.price}€</h3>
            </Row>
            <Row>
              <div className="itemShippingCosts">
                <p style={{ fontSize: '1em', fontWeight: 500, marginBottom: '0.5rem' }}>Shipping costs (calculated at the checkout):</p>
                <p style={{ fontSize: '1em', fontWeight: 400, marginBottom: '1.5rem' }}>Netherlands: {currentprops.product.priceNL == 0 ? 'free' : `${currentprops.product.priceNL}€`}; Europe: {currentprops.product.priceEU == 0 ? 'free' : `${currentprops.product.priceEU}€`}; World: {currentprops.product.priceWORLD == 0 ? 'free' : `${currentprops.product.priceWORLD}€`}</p>
              </div>       
            </Row>

            <Row>
            {currentprops.product.stock <= 0 && (
              <Button
                disabled
                className="mt-3 mb-3"
                style={{ backgroundColor: '#999', color: 'white', border: 'none', padding: '0.75rem 1.875rem', fontSize: '1.1em', cursor: 'not-allowed' }}
              >
                SOLD OUT
              </Button>
            )}
            {currentprops.product.stock >= 1 && (
              <Button
              variant={ousidecart() ? ("success") : ("info")}
              className="button is-small is-outlined is-primary is-pulled-right AddItemToCartButton mt-3 mb-3"
              style={{ backgroundColor: '#C9A45C', color: 'white', border: 'none', padding: '0.75rem 1.875rem', fontSize: '1.1em' }}
              onClick={() => {                trackAddToCart(currentprops.product);                this.addToCart({
                  id: currentprops.product.name,
                  product: currentprops.product,
                  amount: 1
                })}
              }
            >
              {ousidecart() ? ("ADDED TO CART") : ("ADD TO CART")}</Button>
            )}

            </Row>
            <Row className="itemShippingCosts mb-0">
              <p style={{ fontSize: '1em', fontWeight: 400 }}>Safe checkout with <img className="icon" src={stripe} alt="Stripe payment processing"/></p>
            </Row>
            <Row className="bubbleWrap">

            <div className="">
                <img className="icon " src={maestro} alt="Maestro card"/>
                <img className="icon " src={visa} alt="Visa card"/>
                <img className="icon " src={mastercard} alt="Mastercard"/>
                <img className="icon " src={ideal} alt="iDEAL payment"/>

            </div>
            <p style={{ fontSize: '0.9em', fontStyle: 'italic', lineHeight: '1.4', marginTop: '1rem' }}>All pieces sold by Yekaterina Zhmud are carefully and nicely packed in paper and bubble wrap, delivered in a cardboard box filled by air bags. The lot is sent within 3 days after the payment, with track and trace.</p>          

            </Row>
          </Col>

        </Row>
      </Container>) :
    (<div className="column">
    <span className="title has-text-grey-light">
      No products found :( Wait for a bit please
    </span>
    </div>) }
    </>
    )
  }
}

export default withContext(Item);
